export const filterClasses = {
  container: "flex gap-3 flex-wrap items-center",
  filterItem: "min-w-max flex",
  multiValueTag: `
    bg-yellow-50 border-2 border-yellow-400 rounded-md 
    m-1 px-2 text-xs font-semibold text-yellow-700 
    max-w-[120px] flex items-center shadow-sm 
    transition-all duration-200 cursor-default
    hover:shadow-md
  `,
  multiValueText: `
    overflow-hidden text-ellipsis whitespace-nowrap 
    max-w-[90px]
  `,
  multiValueRemove: `
    ml-1.5 cursor-pointer font-bold text-yellow-700 
    p-1 rounded-full flex items-center justify-center 
    w-3 h-3 transition-all duration-200
    hover:bg-yellow-400 hover:text-white
  `,
  moreItemsTag: `
    bg-slate-100 border-2 border-slate-300 rounded-md 
    m-1 px-2 text-xs font-semibold text-slate-600 
    italic cursor-help transition-all duration-200
    hover:bg-slate-200 
  `
};

export const getSelectClasses = (hasValue: boolean) => {
  return hasValue
    ? "select-filter filter-active"
    : "select-filter";
};
